/**
 * Aprobar o rechazar varias solicitudes de eliminación a la vez.
 *
 * Se ejecutan en serie, nunca en paralelo: varias solicitudes pueden apuntar
 * al mismo documento padre (el XML y la contabilización de una misma factura)
 * y cada borrado reescribe ese documento. Un fallo (p. ej. otra supervisora ya
 * la resolvió) no detiene el resto: queda en `failed` con su mensaje.
 *
 * Módulo puro: sin React/Redux/Firestore, para poder testearlo directo.
 */

import { friendlyError } from './deletion_request';

export const runInSeries = async (items, action, { onProgress } = {}) => {
  const ok = [];
  const failed = [];
  if (onProgress) onProgress(0, items.length);
  for (let i = 0; i < items.length; i += 1) {
    const item = items[i];
    try {
      // eslint-disable-next-line no-await-in-loop
      ok.push({ item, result: await action(item) });
    } catch (e) {
      failed.push({ item, message: friendlyError(e, 'No se pudo completar.') });
    }
    if (onProgress) onProgress(i + 1, items.length);
  }
  return { ok, failed };
};

/**
 * La selección solo puede contener lo que está en pantalla: si cambió el
 * filtro o alguien resolvió una, sale. Devuelve el mismo arreglo si no cambió.
 */
export const keepVisible = (selectedKeys, visibleRows) => {
  const visible = new Set(visibleRows.map((r) => r.id));
  const kept = selectedKeys.filter((k) => visible.has(k));
  return kept.length === selectedKeys.length ? selectedKeys : kept;
};

/** Nombres para el modal de confirmación: los primeros `max` y cuántos más. */
export const previewNames = (items, max = 10) => ({
  names: items.slice(0, max).map((r) => r.itemName),
  rest: Math.max(0, items.length - max),
});

const DONE_LABEL = { approve: ['aprobada', 'aprobadas'], reject: ['rechazada', 'rechazadas'] };

/** "6 aprobadas, 1 no se pudo". */
export const summarize = (mode, { ok, failed }) => {
  const [one, many] = DONE_LABEL[mode];
  const head = `${ok.length} ${ok.length === 1 ? one : many}`;
  if (!failed.length) return head;
  return `${head}, ${failed.length} ${failed.length === 1 ? 'no se pudo' : 'no se pudieron'}`;
};
